import { render, staticRenderFns } from "./couponStatistics.vue?vue&type=template&id=30200220&scoped=true&"
import script from "./couponStatistics.vue?vue&type=script&lang=js&"
export * from "./couponStatistics.vue?vue&type=script&lang=js&"
import style0 from "./couponStatistics.vue?vue&type=style&index=0&id=30200220&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30200220",
  null
  
)

export default component.exports